<!--*****************************************************************
  * Copyright (c) Certus Software, 2022.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<section class="banner-section">
  <div class="inner">
    <div class="inner-grid">
      <div>
        <h1 *ngIf="router.url.endsWith('guide')" class="hero">{{'guidePage.title' | translate}}</h1>
        <p *ngIf="!router.url.endsWith('guide')" class="hero s-h1">{{'guidePage.title' | translate}}</p>
      </div>
      <div>
        <div class="divider"></div>
        <div>
          <p class="s-h5">{{'app.footer.support.title' | translate}}</p>
          <div class="contacts">
            <p class="small">
              <a class="email" href="mailto:{{env.resources.websiteOrMail}}">{{env.resources.websiteOrMail}}</a>
            </p>
            <span aria-hidden="true">|</span>
            <p class="small">
              <a class="tel" href="tel:+3614680673">(06 1) 468-0673</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
